const BASE = process.env.REACT_APP_API_URL || 'https://api.kulturfunnel.de/api';

async function req(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export const api = {
  // Clients
  getClients: () => req('/clients'),
  getClient: (id) => req(`/clients/${id}`),
  createClient: (data) => req('/clients', { method: 'POST', body: data }),
  updateClient: (id, data) => req(`/clients/${id}`, { method: 'PUT', body: data }),
  deleteClient: (id) => req(`/clients/${id}`, { method: 'DELETE' }),

  // Actions
  getActions: (clientId) => req(`/actions${clientId ? `?client_id=${clientId}` : ''}`),
  createAction: (data) => req('/actions', { method: 'POST', body: data }),
  markActionDone: (id) => req(`/actions/${id}/done`, { method: 'PUT' }),

  // Audits
  getAudits: () => req('/audits'),
  generateAudit: (data) => req('/audits/generate', { method: 'POST', body: data }),
  updateAuditStatus: (id, status) => req(`/audits/${id}/status`, { method: 'PUT', body: { status } }),

  // AI
  analyse: (query) => req('/ai/analyse', { method: 'POST', body: { query } }),
  generateInsights: () => req('/ai/insights', { method: 'POST' }),
};
